var React = require('react');

function FilterIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m1.08.858h15.84a1 1 0 0 1 .78 1.625l-6.48 8.101a1 1 0 0 0 -.22.625v5.149a1 1 0 0 1 -.4.8l-2 1.5a1 1 0 0 1 -1.6-.8v-6.65a1 1 0 0 0 -.22-.624l-6.48-8.101a1 1 0 0 1 .78-1.625z"}));
}

FilterIcon.defaultProps = {"preserveAspectRatio":"xMinYMin","viewBox":"-3 -2.5 24 24"};

module.exports = FilterIcon;

FilterIcon.default = FilterIcon;
